import React, { Fragment, Component } from "react";
import DataTable from "../../../Datatable/DataTable";

const TableHolder = ({
  risk_table_columns,
  risk_table_rows,
  benchmark_name,
  display_orig_portfolio,
  model_name,
}) => {
  return (
    <Fragment>
      {risk_table_rows.length > 0 ? (
        <Fragment>
          {risk_table_columns.length === 3 &&
          risk_table_rows[0].length === 3 ? (
            <DataTable
              data={risk_table_rows}
              columns={risk_table_columns}
              paging={false}
              searching={false}
            />
          ) : null}

          <Fragment>
            {risk_table_columns.length === 4 &&
            risk_table_rows[0].length === 4 ? (
              <DataTable
                data={risk_table_rows}
                columns={risk_table_columns}
                paging={false}
                searching={false}
              />
            ) : null}
          </Fragment>
          {benchmark_name && display_orig_portfolio ? (
            <div>
              <b>*</b> <small>{benchmark_name}</small>
            </div>
          ) : null}
          {model_name ? (
            <div>
              <small>
                <b>+</b> {model_name}
              </small>
            </div>
          ) : null}
        </Fragment>
      ) : null}
    </Fragment>
  );
};
export default TableHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/RiskStatistic/section1/tableHolder.jsx